module.exports = __webpack_public_path__ + "img/aeroland-software-image-06.e791078f.png";